export default "__VITE_ASSET__C3Rgct2v__"